import { BehaviorSubject } from 'rxjs'
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators'
import { cloneDeep, flatten, isEqual, merge, result, set as _set, isObject } from '../libraries/lodash'
import { STATE_STORAGE_KEY } from '../constants/memory'

// default session state
const browserSessionState = {
  write (state) {
    if (window.sessionStorage) {
      try {
        window.sessionStorage.setItem(
          STATE_STORAGE_KEY,
          JSON.stringify(state)
        )
      } catch (e) {}
    }
  },

  read () {
    if (window.sessionStorage) {
      try {
        return merge({}, JSON.parse(window.sessionStorage.getItem(STATE_STORAGE_KEY)))
      } catch (e) {
        return {}
      }
    }
  }
}

export class SessionState extends BehaviorSubject {
  constructor (store) {
    super(store.read())
    this.pipe(debounceTime(50)).subscribe(store.write)
    this.selectContent = this.toggle.bind(this, ['selected'], 1)
    this.deselectContent = this.toggle.bind(this, ['selected'], 0)
    this.toggleContent = this.toggle.bind(this, ['selected'])
  }


  toggle = (collection, value, group, id) => {
    const ids = flatten([id])
    const state = cloneDeep(this.value)
    ids.forEach(
      id =>
        _set(
          state,
          [...collection, group, id],
          value
        )
    )
    this.next(state)
  }

  reset = () => {
    this.next({})
  }

  set = (...args) => {
    if ([...args].length < 2) {
      if (!isObject(arg1)) {
        throw new Error('updateState expected first argument to be an object if only one value is provided')
      }

      this.next({ ...this.value, ...arg1 })
    } else {
      const arg1 = args[0]
      const arg2 = args[1]
      this.next({
        ...this.value,
        [arg1]: arg2
      })
    }
  }
  observeSelected = (group, ids = null) => {
    return this.pipe(
      map((state) => {
        if (ids) {
          return ids.map(id => ({
            id,
            selected: result(state, ['selected', group, id], 0)
          }))
        }

        return result(state, ['selected', group], {})
      }),
      distinctUntilChanged(isEqual, JSON.stringify)
    ) 
  }
}

export const State = new SessionState(browserSessionState)
export const deselectContent = State.deselectContent
export const observeSelected = State.observeSelected
export const observeState = State
export const selectContent = State.selectContent
export const toggleContent = State.toggleContent
export const updateState = State.set
